import { useState, useEffect } from "react";
import { Check, Loader2, Send, Mail } from "lucide-react";
import { toast } from "sonner";
import api, { apiErr } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Switch } from "../components/ui/switch";

export default function EmailSettings() {
  const [s, setS] = useState(null);
  const [saving, setSaving] = useState(false);
  const [testTo, setTestTo] = useState("");
  const [testing, setTesting] = useState(false);

  useEffect(() => { api.get("/admin/settings").then((r) => { setS(r.data); setTestTo(r.data.email_settings?.owner_email || ""); }); }, []);
  if (!s) return <Loader2 className="h-6 w-6 animate-spin text-primary mx-auto mt-10" />;

  const set = (k, v) => setS((p) => ({ ...p, email_settings: { ...p.email_settings, [k]: v } }));

  const save = async () => {
    setSaving(true);
    try { await api.put("/admin/settings", { email_settings: s.email_settings }); toast.success("تم الحفظ"); }
    catch (e) { toast.error(apiErr(e)); } finally { setSaving(false); }
  };

  const sendTest = async () => {
    if (!testTo) return;
    setTesting(true);
    try { await api.post("/admin/settings/test-email", { to: testTo }); toast.success("تم إرسال رسالة الاختبار بنجاح"); }
    catch (e) { toast.error(apiErr(e)); } finally { setTesting(false); }
  };

  return (
    <div className="max-w-2xl">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold">إعدادات البريد الإلكتروني</h1>
        <Button onClick={save} disabled={saving} className="rounded-full font-semibold" data-testid="save-email-btn">
          {saving ? <Loader2 className="h-4 w-4 animate-spin me-1" /> : <Check className="h-4 w-4 me-1" />} حفظ
        </Button>
      </div>

      <section className="rounded-2xl bg-card cb-card-shadow p-5 mb-5 space-y-4">
        <div>
          <Label className="mb-1 block text-xs">بريد استلام الحجوزات (صاحبة الصالون)</Label>
          <Input value={s.email_settings.owner_email} onChange={(e) => set("owner_email", e.target.value)} className="rounded-xl h-11" dir="ltr" data-testid="owner-email-input" />
          <p className="text-xs text-muted-foreground mt-1">تصل جميع إشعارات الحجوزات الجديدة إلى هذا البريد.</p>
        </div>
        <label className="flex items-center justify-between py-1">
          <span className="text-sm">إرسال بريد تأكيد للعميلة عند الحجز</span>
          <Switch checked={s.email_settings.customer_confirmation_enabled} onCheckedChange={(v) => set("customer_confirmation_enabled", v)} data-testid="toggle-customer-email" />
        </label>
        <label className="flex items-center justify-between py-1">
          <span className="text-sm">إرسال إشعار لصاحبة الصالون عند كل حجز</span>
          <Switch checked={s.email_settings.owner_notification_enabled} onCheckedChange={(v) => set("owner_notification_enabled", v)} data-testid="toggle-owner-email" />
        </label>
        <label className="flex items-center justify-between py-1">
          <span className="text-sm">إرسال تذكير للعميلة قبل الموعد بـ 24 ساعة</span>
          <Switch checked={s.email_settings.reminder_enabled !== false} onCheckedChange={(v) => set("reminder_enabled", v)} data-testid="toggle-reminder-email" />
        </label>
      </section>

      <section className="rounded-2xl bg-card cb-card-shadow p-5 space-y-3">
        <h2 className="font-bold flex items-center gap-2"><Mail className="h-5 w-5" /> اختبار البريد</h2>
        <p className="text-xs text-muted-foreground">يُرسل بريد الإلكتروني عبر خدمة آمنة مُدارة من الخادم. جربي الإرسال للتأكد.</p>
        <div className="flex gap-2">
          <Input value={testTo} onChange={(e) => setTestTo(e.target.value)} className="rounded-xl h-11 flex-1" dir="ltr" placeholder="email@example.com" data-testid="test-email-input" />
          <Button onClick={sendTest} disabled={testing} className="rounded-full" data-testid="send-test-email-btn">
            {testing ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Send className="h-4 w-4 me-1" /> إرسال</>}
          </Button>
        </div>
      </section>
    </div>
  );
}
